module.exports = __webpack_public_path__ + "img/blue_162.0f503431.png";